import { UserPermissionKeys } from 'app/security/authorization/user-permission-keys';
import { WidgetDisplayType } from 'app/views/dashboard/widgets/widget-display-type.enum';
import { WidgetSize } from 'app/views/dashboard/widgets/widget-size';
import { CONFIG } from '../../core/config';
import { WidgetDataType } from '../../views/dashboard/widgets/widget-data-type';
import { WidgetDateRangeType } from '../../views/dashboard/widgets/widget-date-range-type';
import { ViewModel } from '../view-model';
import { WidgetParameter } from './widget-parameter';

export class Widget implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Widget';
  public readonly apiRoute: string = CONFIG.apiRoutes.widget;

  public widgetId: string;

  public widgetDataType: WidgetDataType;

  public widgetDisplayType: WidgetDisplayType;

  public dateRangeType: WidgetDateRangeType;

  public startDate: Date;

  public endDate: Date;

  public dynamicDaysStart: number;

  public dynamicDaysEnd: number;

  public data: any;

  public widgetSize: WidgetSize;

  public title: string;

  public widgetParameters: WidgetParameter[] = new Array<WidgetParameter>();

  public widgetItemizedDataParameters: WidgetParameter[] = new Array<WidgetParameter>();

  public orgTreeNodeId: string;

  public json(): any {
    return this;
  }

  loadFromJson(data: any) {
    this.widgetId = data.widgetId;
    this.widgetDataType = data.widgetDataType;
    this.dateRangeType = data.dateRangeType;
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.dynamicDaysStart = data.dynamicDaysStart;
    this.dynamicDaysEnd = data.dynamicDaysEnd;
    this.widgetSize = data.widgetSize;
    this.title = data.title;
    this.widgetDisplayType = data.widgetDisplayType;

    this.data = JSON.parse(data.data);
    if (data.widgetParameters) {
      data.widgetParameters.forEach(parameter => {
        this.widgetParameters.push(parameter);
      });
    }
    if (data.widgetItemizedDataParameters) {
      data.widgetItemizedDataParameters.forEach(parameter => {
        this.widgetItemizedDataParameters.push(parameter);
      });
    }
  }

  public static getRequiredPermissionsForWidget(widgetDataTypeEnum: WidgetDataType): string[] {
    const permissionsKeys = new UserPermissionKeys();
    switch (widgetDataTypeEnum) {
      case WidgetDataType.AssetCount:
        return [permissionsKeys.hierarchyHierarchyItemRead];
      case WidgetDataType.CompletedReports:
        return [permissionsKeys.idmsInspectionReportRead, permissionsKeys.idmsThicknessReportRead];
      case WidgetDataType.HighRiskItems:
        return [permissionsKeys.hierarchyHierarchyItemRead];
      case WidgetDataType.MitigationsDue:
        return [permissionsKeys.rbiMitigationsRecommentationRead];
      case WidgetDataType.MitigationsDueByMonth:
        return [permissionsKeys.rbiMitigationsRecommentationRead];
      case WidgetDataType.OverdueMitigations:
        return [permissionsKeys.rbiMitigationsRecommentationRead];
      case WidgetDataType.PlannedMaintenanceDistribution:
        return [permissionsKeys.maintenanceMaintenanceStrategyRead];
      case WidgetDataType.PlannedMaintenanceImprovements:
        return [permissionsKeys.maintenanceMaintenanceOptimizationRead];
      case WidgetDataType.RiskDistribution:
        return [permissionsKeys.rbiRiskAnalysisModelRunRead];
      default:
        return [];
    }
  }
}
